// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import ClaimUseAmount from '@deere/cps-it.warranty-model-factory/lib/claim-use-amount';
import EditableField from '../../../../../shared/components/editable-field/index';
import FormattedNumberInput from '../../../../../shared/components/formatted-number-input';
import LabeledFormInput from '../../../../../shared/components/labeled-form-input';
import ValidationAndVsrErrorMessages from '../../validation-and-vsr-error-messages';
import {buildNumber} from '../../../../../shared/services/build-number';
import {getFieldClassName} from '../../../services/claim-shared-helper';

function handleInputBlur(index, value) {

    this.onInputBlur(value, index);

}

function handleInputChange(index, value) {

    this.onInputChange(value, index);

}

const formatValue = (formatter, value) => {

    const formattedValue = value ? buildNumber(parseFloat(value)) : value;

    return formatter ? formatter(value) : formattedValue;

};

const isAllowed = value => value.replace(/,/g, '').length <= 6;

const AmountOfUseWithCompliance = props =>
    <LabeledFormInput
        className={getFieldClassName(props.className, props.isValid, props.highlightClass)}
        label='AMOUNT_OF_USE'
    >
        {props.useAmounts.map((useAmount, index) =>
            <div key={useAmount.unit.key}>
                <EditableField
                    className='amount'
                    isEditable={props.isEditable}
                    value={formatValue('', useAmount.amount)}
                >
                    <FormattedNumberInput
                        allowNegative={false}
                        className='amount'
                        decimalPrecision={0}
                        isAllowed={isAllowed}
                        isValidInput={props.isValidInput}
                        onBlur={handleInputBlur.bind(props, index)}
                        onValueChange={handleInputChange.bind(props, index)}
                        value={useAmount.amount}
                    />
                </EditableField>
                <div className='unit'>{useAmount.unit.value}</div>
            </div>
        )}
        <ValidationAndVsrErrorMessages
            errorMessage='AMOUNT_OF_USE_IS_REQUIRED'
            isValid={props.isValid}
            vsrMessage={props.vsrMessage}
        />
    </LabeledFormInput>;

AmountOfUseWithCompliance.displayName = 'AmountOfUseWithCompliance';
AmountOfUseWithCompliance.propTypes = {
    className: PropTypes.string.isRequired,
    highlightClass: PropTypes.string,
    isEditable: PropTypes.bool.isRequired,
    isValid: PropTypes.bool.isRequired,
    isValidInput: PropTypes.func,
    onInputBlur: PropTypes.func.isRequired,
    onInputChange: PropTypes.func.isRequired,
    useAmounts: PropTypes.arrayOf(PropTypes.instanceOf(ClaimUseAmount)).isRequired,
    vsrMessage: PropTypes.string
};
AmountOfUseWithCompliance.defaultProps = {
    isValidInput: value => value < 1000000
};
export default AmountOfUseWithCompliance;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-fields/amount-of-use/amount-of-use-with-compliance.js